'use strict';

var consts = require('./consts.js');

// Функция создает уникальный слушатель события АУФ из соседних вкладок.
// При отправке нужного message между вкладками браузера, будет вызван callback что передан в последний вызов функции subscribeOnLoginSuccess
const subscribeOnLoginSuccess = (callback) => {
    if (typeof window === 'undefined') {
        return () => { };
    }
    // eslint-disable-next-line @typescript-eslint/init-declarations
    let broadcast = null;
    const uniqSymbol = Symbol('Uniq key for authentication success callback');
    window.sravni = {
        ...window.sravni,
        authentication: {
            // eslint-disable-next-line no-undef
            ...(window.sravni?.authentication ?? {}),
            loginSuccessPostMessageSymbol: uniqSymbol,
        },
    };
    const handler = (event) => {
        const canExecuteCallback = window.sravni.authentication.loginSuccessPostMessageSymbol === uniqSymbol;
        if (!canExecuteCallback) {
            return false;
        }
        const { authMessageType, payload } = event.data;
        const sourceWindow = event.source;
        if (authMessageType !== consts.AUTH_SUCCESSFULL_LOGIN_MESSAGE_NAME || payload !== true) {
            return false;
        }
        if (sourceWindow && sourceWindow.constructor.name === 'Window')
            sourceWindow.close();
        callback();
    };
    if ('BroadcastChannel' in window) {
        broadcast = new BroadcastChannel(consts.AUTH_BROADCAST_CHANNEL_NAME);
        broadcast.addEventListener('message', handler, false);
    }
    window.addEventListener('message', handler, false);
    return () => {
        window.sravni.authentication.loginSuccessPostMessageSymbol = undefined;
        window.removeEventListener('message', handler, false);
        if (broadcast) {
            broadcast.removeEventListener('message', handler, false);
            broadcast.close();
        }
    };
};
// Функция создает уникальный слушатель события АУФ из соседних вкладок.
// При отправке нужного message между вкладками браузера, будет вызван callback что передан в последний вызов функции subscribeOnLoginFailure
const subscribeOnLoginFailure = (callback) => {
    if (typeof window === 'undefined') {
        return () => { };
    }
    // eslint-disable-next-line @typescript-eslint/init-declarations
    let broadcast = null;
    const uniqSymbol = Symbol('Uniq key for authentication failure callback');
    window.sravni = {
        ...window.sravni,
        authentication: {
            // eslint-disable-next-line no-undef
            ...(window.sravni?.authentication ?? {}),
            loginFailurePostMessageSymbol: uniqSymbol,
        },
    };
    const handler = (event) => {
        const canExecuteCallback = window.sravni.authentication.loginSuccessPostMessageSymbol === uniqSymbol;
        if (!canExecuteCallback) {
            return false;
        }
        const { authMessageType, payload } = event.data;
        if (authMessageType !== consts.AUTH_FAILURE_LOGIN_MESSAGE_NAME || payload !== true) {
            return false;
        }
        callback();
    };
    if ('BroadcastChannel' in window) {
        broadcast = new BroadcastChannel(consts.AUTH_BROADCAST_CHANNEL_NAME);
        broadcast.addEventListener('message', handler, false);
    }
    window.addEventListener('message', handler, false);
    return () => {
        window.sravni.authentication.loginFailurePostMessageSymbol = undefined;
        window.removeEventListener('message', handler, false);
        if (broadcast) {
            broadcast.removeEventListener('message', handler, false);
            broadcast.close();
        }
    };
};

exports.subscribeOnLoginFailure = subscribeOnLoginFailure;
exports.subscribeOnLoginSuccess = subscribeOnLoginSuccess;
//# sourceMappingURL=subscriptions.js.map
